// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const keturaColors: ColorType = { ...colorPalette, primary: '#ff1616', secondary: '#ff1616' }

export const lightTheme = {
  colors: keturaColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: keturaColors.light,
    select: '#fafafa',
    footerTop: '#eee',
  },
  text: {
    primary: keturaColors.dark,
    secondary: keturaColors.grayText,
    disabled: keturaColors.dark,
    link: keturaColors.dark,
    hint: keturaColors.dark,
    highlight: keturaColors.primary,
    gray: keturaColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#ffffff',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: keturaColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: keturaColors.dark,
    color: keturaColors.dark,
    border: keturaColors.primary,
    scrollbarThumb: keturaColors.primary,
    programTitle: keturaColors.primary,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: keturaColors.dark,
        selected: keturaColors.dark,
        progress: rgba(keturaColors.primary, 0.3),
        past: rgba(keturaColors.primary, 0.3),
        pastSelected: keturaColors.dark,
        pastHover: keturaColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(keturaColors.primary, 0.1),
      },
      text: {
        empty: keturaColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: keturaColors.dark,
    subTitle: keturaColors.grayText,
    bg: keturaColors.dark,
    number: keturaColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
